import { POST } from 'js/constants/requestMethods';
import { CALL_PRIVATE_API } from 'js/middleware/api';
import { Action, Dispatch, Store } from 'redux';
import * as actionTypes from '../../constants/actionTypes';
import { RESOURCE_TYPE_DATA_SET, RESOURCE_TYPE_FLOW } from 'js/constants/resourceTypes';

type DocRecommendationPayload = {
  id: number;
  resourceType: string;
};

const docRecommendationEndpoint = {
  [RESOURCE_TYPE_DATA_SET](id) {
    return `/data_sets/${id}/docs/recommendation`;
  },
  [RESOURCE_TYPE_FLOW](id) {
    return `/flows/${id}/docs/recommendation`;
  },
};

export const getDocRecommendation =
  ({ id, resourceType }) =>
  (dispatch: Dispatch<any>, getState: Store<any, Action>['getState']) => {
    const endpoint = docRecommendationEndpoint[resourceType](id);

    return dispatch({
      [CALL_PRIVATE_API]: {
        types: [
          actionTypes.DOC_RECOMMENDATION_REQUEST,
          actionTypes.DOC_RECOMMENDATION_SUCCESS,
          actionTypes.DOC_RECOMMENDATION_FAILURE,
        ],
        endpoint,
        requestMethod: POST,
        ignoreErrors: true,
        requestInfo: {
          id,
          resourceType,
        },
      },
    });
  };

export const clearGenAiRecommendation = ({ id, resourceType }) => {
  return {
    type: actionTypes.CLEAR_DOC_RECOMMENDATION,
    payload: {
      id,
      resourceType,
    },
  };
};
